import getLuxonImpl from '../libraries/timezone/timeboxImpl';
const OrderLineOptionsGetter = {
    dailySpending: (options) => {
        const { Formats: TimeBoxFormats, timebox: TimeBox } = getLuxonImpl();
        const today = TimeBox.realNow().format(TimeBoxFormats.YYYY_MM_DD).exec();
        return (options && options.dailySpending && options.dailySpending[today]) || 0;
    },
};
export default Object.freeze(OrderLineOptionsGetter);
